export const INTEGRATION_AUTH_TYPES = {
  api_key: 'API Key',
  oauth2: 'OAuth 2.0',
  basic: 'Basic',
}

export enum IntegrationState {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  EXPIRED = 'EXPIRED',
  IN_PROGRESS = 'IN-PROGRESS',
}
